// Single source of truth for the canvas grid unit, shared by
// CanvasElement.tsx, DraggableResizableElement.tsx and
// PrintFormatDesignerPage.tsx. Keep this in sync with PX_PER_MM/
// PAGE_DIMENSIONS_MM in ../types.ts if the two ever need to be reconciled
// (tracked as a follow-up in ADR-103 §5 Consequences risk item).
export const GRID_UNIT_PX = 24;

/**
 * Converts a raw pixel drag delta (from @dnd-kit's DragEndEvent.delta) into
 * a whole number of grid units, rounding to the nearest unit. Exported as a
 * pure function specifically so drag-snapping behavior can be unit tested
 * without simulating real pointer events through @dnd-kit's sensors in
 * jsdom (which is unreliable/verbose) — see __tests__/gridMath.test.ts.
 */
export function pixelDeltaToGridUnits(deltaPx: number, gridUnitPx: number = GRID_UNIT_PX): number {
  return Math.round(deltaPx / gridUnitPx);
}
